import { currencies } from '@pubstack/common/src/currency'
import { useAtomValue } from 'jotai'
import { useMemo } from 'react'
import { currentScopeState } from '~/state'

export const useScopeCurrency = () => {
  const { currencyCode } = useAtomValue(currentScopeState)
  return useMemo(() => currencies[currencyCode], [currencyCode])
}
